/**
 * Zod input schemas: businessCard. Split out of the one big schemas.ts (Oct 2026) so a session opens only the tool it
 * works on; nothing changed in the schemas themselves. Import as before, from '@daaily/shared' (or './schemas.js'
 * inside shared); the barrel re-exports every file in this folder. Shared primitives (EmailSchema, MonthSchema, …)
 * live in primitives.ts; cross-tool references are explicit imports between these files.
 */
import { z } from 'zod';
// ── Business card (Sep 2026) ───────────────────────────────────────────────
const phoneish = z.string().trim().max(40).regex(/^[+\d][\d\s().-]*$|^$/, 'Phone: digits, spaces, +, ( ) - only');
export const BusinessCardSaveSchema = z.object({
    enabled: z.boolean(),
    workPhone: phoneish.nullish(),
    mobile: phoneish.nullish(),
    linkedin: z.string().trim().max(200).nullish(),
    social: z.record(z.enum(['instagram', 'facebook', 'x', 'youtube', 'tiktok']), z.string().trim().max(200)).nullish(),
    website: z.string().trim().max(200).nullish(),
    website2: z.string().trim().max(200).nullish(),
    brand: z.enum(['daaily', 'archdaily', 'designboom']).nullish(),
    tagline: z.string().trim().max(120).nullish(),
    office: z.string().trim().max(300).nullish(),
    show: z.record(z.enum(['email', 'workPhone', 'mobile', 'linkedin', 'website', 'office', 'photo']), z.union([z.enum(['public', 'exchange', 'hidden']), z.boolean()])).nullish(),
    exchangeEnabled: z.boolean().nullish(),
    /** New token — the old QR codes stop working. */
    rotate: z.boolean().nullish(),
});
export const BusinessCardLeadToSfdcSchema = z.object({ leadId: z.string().trim().min(1).max(64) });
/** Public exchange-form submission (HTTP, not a callable). */
export const CardExchangeSubmitSchema = z.object({
    firstName: z.string().trim().min(1, 'First name is required.').max(60),
    lastName: z.string().trim().min(1, 'Last name is required.').max(60),
    company: z.string().trim().max(120).nullish(),
    email: z.string().trim().toLowerCase().email().max(200),
    phone: phoneish.nullish(),
    jobTitle: z.string().trim().max(120).nullish(),
    note: z.string().trim().max(1000).nullish(),
    consent: z.literal(true, { errorMap: () => ({ message: 'Consent is required.' }) }),
    /** Honeypot — must stay empty. */
    website_url: z.string().max(0).nullish(),
});
//# sourceMappingURL=businessCard.js.map